import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const catalogIndexPage = catalogPlugin.getExtension('page:catalog').override({
  params: {
    noHeader: true,
    loader: async () =>
      import('./CatalogIndexPage').then(module => <module.CatalogIndexPage />),
  },
});

export const catalogEndStatePlugin = catalogPlugin.withOverrides({
  title: 'Catalog',
  extensions: [catalogIndexPage],
});

const systemHealthContent = EntityContentBlueprint.make({
  name: 'system-health',
  params: {
    path: '/health',
    title: 'System health',
    group: 'deployment',
    filter: entity => entity.kind.toLocaleLowerCase('en-US') === 'system',
    loader: async () =>
      import('./SystemHealthContent').then(module => (
        <module.SystemHealthContent />
      )),
  },
});

export const catalogEndStateModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [systemHealthContent],
});
